import React from 'react'
import * as S from './ShipmentSelector.styled'
import StockItem from '../../libs/Stock/StockItem/StockItem'
import { useShipment } from '@entities/shipment/model'
import { useStockById } from '@entities/stocks/model'
import { useOpenStockSelectorWithBasketItems } from 'src/features/shipment-selector/hooks'

const ShipmentSelector = () => {
    const shipment = useShipment()
    const stock = useStockById(shipment.stockId)
    const openStockSelectorWithBasketItems = useOpenStockSelectorWithBasketItems()
    return (
        <S.Container>
            <S.IconContainer>
                <S.Image />
            </S.IconContainer>
            <S.ShipmentContainer>
                <S.ShipmentSelectorBlock data-stock-selector onClick={openStockSelectorWithBasketItems}>
                    <S.ShipmentTitle>Аптека самовывоза</S.ShipmentTitle>
                    <S.ShipmentContent>
                        {stock ? (
                            <StockItem
                                stockId={stock.id}
                                isMetroLocation={stock.isMetroLocation}
                                name={stock.name}
                                title={stock.title}
                                metroColor={stock.metroColor}
                                isHover
                            />
                        ) : (
                            <S.SeclectedShipmentTextButton>Ничего не выбрано</S.SeclectedShipmentTextButton>
                        )}
                    </S.ShipmentContent>
                </S.ShipmentSelectorBlock>
            </S.ShipmentContainer>
            {/*    {isShowedSelectorStock && (
                <SelectorStock
                    goodIds={basketItems.map((x) => x.webData.goodId)}
                    // closeHandler={toggleIsShowedSelectorStockHandler}
                    cityId={shipment.cityId}
                />
            )}*/}
        </S.Container>
    )
}

export default ShipmentSelector
